export function fixFractionFormat(value: unknown): string {
  if (!value || typeof value !== 'string') return String(value ?? '');
  // Matches patterns like "1/4 1" or "1/2 2" and swaps them to "1 1/4", "2 1/2"
  const match = value.trim().match(/^(\d+\/\d+)\s+(\d+)$/);
  if (match) {
    return `${match[2]} ${match[1]}`;
  }
  return value;
}

export function parseSafeNumber(value: unknown): number {
  if (value === null || value === undefined || value === '') return 0;
  if (typeof value === 'number') return isNaN(value) ? 0 : value;
  const cleanStr = String(value).replace(/[^0-9.-]/g, '');
  return parseFloat(cleanStr) || 0;
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  return function (this: any, ...args: Parameters<T>) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export function preventSpreadsheetFormula(value: unknown): unknown {
  if (typeof value === 'string' && /^[=+\-@]/.test(value)) {
    return `'${value}`;
  }
  return value;
}

export function escapeHtml(value: unknown): string {
  return String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;',
  }[char] || char));
}

export function getSafeAssetUrl(value: unknown): string | null {
  if (!value) return null;
  try {
    const url = new URL(String(value), window.location.origin);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/api/kickoffs/')) {
      return null;
    }
    return `${url.pathname}${url.search}`;
  } catch {
    return null;
  }
}
